const asideFilterParent = document.querySelector(".aside-filter-parent.facets-wrapper");
let allMobileDetails = document.querySelectorAll(".main__facets-container #FacetsWrapperDesktop details");
allMobileDetails?.forEach((details) => {
  details?.addEventListener("click", (event) => {
    handleDetailsOpen(event);
  });
});

asideFilterParent?.addEventListener("click", (event) => {
  if (window.innerWidth < 999) {
    if (event.target === asideFilterParent) {
      closeFacetsOnOverlayClick();
    }
  }
});

function closeFacetsOnOverlayClick() {
 
  let sortingModal = document.querySelector(".custom_sort_modal.custom_sort_modal_mobile");
  
  let filterModal = document.querySelector(".main__facets-container.facets-container");
  
  if (sortingModal.style.display == "block") {
    let closeBtn = sortingModal.querySelector("div[data-modal]");
   
    closeBtn.click();
  } else if (filterModal.style.display == "flex") {
    let closeBtn = filterModal.querySelector("div[data-modal]");
   
    closeBtn.click();
  }
}

function handleDetailsOpen(event) {
  let clickedDetails = event.target.closest("details.facets__disclosure-vertical");
  if(!clickedDetails.style.display == 'none') {
  if (!clickedDetails.hasAttribute("open")) {
    allMobileDetails.forEach((details) => {
      let summary = details.querySelector("summary.facets__summary");
      details.removeAttribute("open");
      summary.setAttribute("aria-expanded", "false");
    });
    setTimeout(() => {
      if (event.target.closest("details.facets__disclosure-vertical")) {
        let clickedDetails = event.target.closest("details.facets__disclosure-vertical");
        let clickedSummary = event.target.closest("details.facets__disclosure-vertical summary.facets__summary");
        clickedSummary.setAttribute("aria-expanded", "true");
        clickedDetails.setAttribute("open", "");
      }
    }, 100);
  }
  }
}

function openCusotmSortings(e) {
  let sortingModal = e.nextElementSibling;
  sortingModal?.classList.toggle("open_custom_sort");
}

function applySorting(e) {
  let sortingToApply = e.getAttribute("value");
  let mainSortForm = document.querySelector("#FacetSortForm");
  let mainSortSelect = mainSortForm.querySelector("select");

  mainSortSelect.value = sortingToApply;
  document.querySelector("#FacetSortForm")?.dispatchEvent(new Event("input", { bubbles: true }));

  sessionStorage.removeItem("sorting-applied");
  sessionStorage.setItem("sorting-applied", sortingToApply);

  applyActiveSort();
}

function applyActiveSort() {
  let appliedSort = sessionStorage.getItem("sorting-applied");
  if (appliedSort) {
    let sortedElement = document.querySelectorAll('.custom-sort-option[value="' + appliedSort + '"]');
    let allSortedElement = document.querySelectorAll(".custom-sort-option");
    allSortedElement.forEach((ele) => {
      ele.classList.remove("sort-active");
    });
    if (sortedElement) {
      sortedElement.forEach((ele) => {
        ele?.classList.add("sort-active");
      });
    }
  }
}

// Grid layout switcher for mobile
window.changeMobileGrid = function (e) {
  const grid = document.querySelector(".main-grid-container");
  if (!grid) return;

  const gridCards = grid.querySelectorAll("li");
  const gridIcons = document.querySelectorAll(".grid-icon");

  // Remove 'active-grid' from all buttons
  gridIcons.forEach((icon) => icon.classList.remove("active-grid"));
  e.classList.add("active-grid");

  const gridToSet = e.getAttribute("data-grid");

  gridCards.forEach((card) => {
    // Set <li> layout
    card.style.flex = gridToSet === "2" ? "0 0 48%" : "0 0 100%";

    // Set max-width on inner wrapper
    const wrapper = card.querySelector(".main-card-wrapper");
    if (wrapper) {
      const wrapper = card.querySelector(".main-card-wrapper");
if (wrapper && gridToSet === "2") {
  const screenWidth = window.innerWidth;

  if (screenWidth < 400) {
    wrapper.style.maxWidth = "140px";
  } else if (screenWidth >= 400 && screenWidth < 768) {
    wrapper.style.maxWidth = "160px";
  } else {
    wrapper.style.maxWidth = "";
  }
} else if (wrapper) {
  wrapper.style.maxWidth = "";
}

    }
  });

  // Optionally store preference (uncomment if needed)
  // localStorage.setItem("preferredGrid", gridToSet);
};

// Auto-apply layout on page load (mobile only)
function onLoadGridSwitcher() {
  if (window.innerWidth > 998) return;
  const grid = document.querySelector(".main-grid-container");
  if (!grid) return;
  const gridCards = grid.querySelectorAll("li");
  const activeBtn = document.querySelector(".mobile-grid-changer .grid-icon.active-grid");
  if (!activeBtn) return;
  const gridToSet = activeBtn.getAttribute("data-grid");
  gridCards.forEach((card) => {
    card.style.flex = gridToSet === "2" ? "0 0 48%" : "0 0 100%";
    const wrapper = card.querySelector(".main-card-wrapper");
    if (wrapper) {
      if (gridToSet === "2") {
        const screenWidth = window.innerWidth;
        if (screenWidth < 400) {
          wrapper.style.maxWidth = "140px";
        } else if (screenWidth >= 400 && screenWidth < 768) {
          wrapper.style.maxWidth = "160px";
        } else {
          wrapper.style.maxWidth = "";
        }
      } else {
        wrapper.style.maxWidth = "";
      }
    }
  });
}
window.addEventListener("resize", onLoadGridSwitcher);
// Only run onLoadGridSwitcher after AJAX grid updates, not on initial DOMContentLoaded

function openMobileFacets(value) {
  let modalOutLay = document.querySelector(".aside-filter-parent");
  let body = document.body;
  let modalToOpen = document.querySelector(`[data-modal-open="${value}"]`);
  if (window.innerWidth <= 999) {
    if (modalToOpen) {
      modalOutLay.style.display = "block";
      body.style.overflow = "hidden";
      if (value == "sort") {
        modalToOpen.style.display = "block";
      } else if (value == "filter") {
        modalToOpen.style.display = "flex";
      }
    }
  }
}

function closeMobileFacets(value) {
  let modalOutLay = document.querySelector(".aside-filter-parent");
  let modalToClose = document.querySelector(`[data-modal-open="${value}"]`);
  let body = document.body;
  if (window.innerWidth <= 999) {
    if (modalToClose) {
      body.style.overflow = null;
      modalOutLay.style.display = "none";
      modalToClose.style.display = "none";
    }
    closeDetails(modalToClose);
  }
}

function closeDetails(modalToClose) {
  let details = modalToClose.querySelectorAll('details');
  details.forEach((detail) => {
    detail.removeAttribute('open');
    let summary = detail.querySelector('summary');
    summary.setAttribute('aria-expanded','false')
  })
}

function removeBrandQuick() {
  let quickBrandFilters = document.querySelector(".quick_brand_filter_parent");
   let closebtn = document.querySelector('.mobile_filter_heading_close .closeFilterBtn');
  if(closebtn){
    console.log(closebtn,'closebtn');

   closebtn.click();
 }
  if (quickBrandFilters) {
    let filterTabs = quickBrandFilters.querySelectorAll(".quick_brand_filter");
    filterTabs.forEach((tab) => {
      if (tab.classList.contains("quick_brand_filter_active")) {
        tab.classList.remove("quick_brand_filter_active");
      }
    });
  }
}

function clearMobileSorting() {
  let realClearBtn = document.querySelector(".mobile_btn_parent.active-facets-mobile a");
  let sortingOptions = document.querySelectorAll(".custom-sort-option");
  // realClearBtn.click();
  sortingOptions.forEach((option) => {
    option?.classList.remove("sort-active");
  });
  let closebtn = document.querySelector('.mobile_sort_heading_close .closesortbtn');
  if(closebtn){
   closebtn.click();
 }
  sessionStorage.removeItem("sorting-applied");
}
window.addEventListener("DOMContentLoaded", applyActiveSort);

document.addEventListener("DOMContentLoaded", function () {

});

window.handleInfiniteScroll = function(){
 window.onClickCollectionPagination = async (link, event) => {
      document.querySelector('.infinite_pagination_colleciton').style.display="none";
   document.querySelector(".rotating").style.display = "flex";

      event.preventDefault();
      link.style.width = `${link.offsetWidth}px`;
      link.style.height = `${link.offsetHeight}px`;
      link.innerHTML = `
      <div class="spinner-border spinner-border-sm mx-auto" role="status" style="width: 1.2rem; height: 1.2rem">
          <span class="visually-hidden">Loading...</span>
      </div>
    `;
      const respoonse = await fetch(link.getAttribute('href'));
      const data = await respoonse.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(data, 'text/html');
      document
        .querySelector('.collection #product-grid')
        .insertAdjacentHTML('beforeend', newDocument.querySelector('.collection #product-grid').innerHTML);
      document
        .querySelector('#product-grid-Pagination')
        .replaceWith(newDocument.querySelector('#product-grid-Pagination'));
      // window.observer1.observe(document.querySelector('#product-grid-Pagination'));
      const customEvent = new CustomEvent('ks.collection.paginated');
      link.dispatchEvent(customEvent);
      if(typeof ReloadSmartWishlist !== "undefined"){ ReloadSmartWishlist();}
      onLoadGridSwitcher();
    };

};
handleInfiniteScroll();
window.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth >= 999) {
    window.addEventListener("click", (event) => {
      handleClosingSort(event);
    });
  }
});

function handleClosingSort(event) {
  let sortElement = document.querySelector(".custom-sorting_wrapper .custom_sort_modal");
  let clickedElement = event.target;
  if (clickedElement.closest(".custom-sorting_wrapper") == null && sortElement.classList.contains("open_custom_sort"))
    sortElement.classList.remove("open_custom_sort");
}

const elementToTrack = document.querySelector(".footer__content-top");

const handleScroll = () => {
  if(window.innerWidth > 999) {
    const elementRect = elementToTrack.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    if (elementRect.top > windowHeight) {
      let filterElement = document.querySelector(".aside-filter-parent#main-collection-filters");
      filterElement.classList.remove("footer-in-sight");
    } else {
      let filterElement = document.querySelector(".aside-filter-parent#main-collection-filters");
      filterElement.classList.add("footer-in-sight");
    }
  };
}
window.addEventListener("scroll", throttle(handleScroll, 100));
// ✅ Cancel scroll animations on initial page load for product grid
document.addEventListener("DOMContentLoaded", () => {
  document
    .getElementById("ProductGridContainer")
    ?.querySelectorAll(".scroll-trigger")
    .forEach((el) => {
      el.classList.add("scroll-trigger--cancel");
    });
});